function patientItemBackground(status, palette) {
    if (status.inactive) return palette.inactiveBackground;
    if (status.blocking) return palette.blockingBackground;
    if (status.validated) return palette.validatedBackground;
    if (status.active) return palette.activeBackground;
    return "transparent";
}

function patientItemIndicator(status, palette) {
    if (status.active) return palette.activeIndicator;
    if (status.inactive) return palette.inactiveIndicator;
    if (status.blocking) return palette.blockingIndicator;
    if (status.validated) return palette.validatedIndicator;
    return null;
}

export function controlePatientStatusStyle(status, palette) {
    const indicator = patientItemIndicator(status, palette);
    return {
        background: patientItemBackground(status, palette),
        boxShadow: indicator ? `inset 3px 0 0 ${indicator}` : "none",
    };
}
